import request from "@/utils/request";

export function getAccounts() {
  return request({
    url: "/rules/suppressions",
    method: "get"
  });
}


export function createAccount(data) {
  return request({
    url: "/rules/suppressions",
    method: "post",
    data
  });
}

export function deleteAccount(login) {
  return request({
    url: "/rules/suppressions/" + login,
    method: "delete",
  });
}

export function downloadAccount() {
  return request({
    url: "/rules/suppressions/download",
    method: "post"
  }, {
    responseType: 'blob'
  });
}
export function uploadAccount(formData) {
  return request.post('/rules/suppressions/upload',
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
  );
}
